export default {
    common: {
        "slogan":"腾达飞快拆，项目快人一步",
        home: "首页",
        category:"商品分类",
        address:"我的地址",
        order:"我的订单",
        favorite:"我的收藏",
        cart:"购物车",
        about:"关于我们",
        agreement:"免责申请",
        concat:"联系我们",
        logout:"安全退出",
        search:"搜索",
        input:"请输入商品名称或型号",
        visit:"前访问人次：",
        start:"起",
        quantity:"数量",
        back_home:"返回首页",
        
        user_center:"用户中心",
        new_order:"创建订单",
        order_detail:"订单详情",
        close:"关闭",
        pay:"订单支付",
        confirm_logout:"您确认要退出账号？",
        confirm:"确认",
        confirm_delete:"确认删除？",
        post_sales:"售后须知",
        faq:"常见问题",
    },
    category1s: [
        "五金工具",
        "快拆系统",
        "摄影配件",
        "车载骑行配件",
        "导光柱",
        "户外配件",
    ],
    home:{
        "productCategories":"产品分类",
        "newProducts":"最近上架",
        "hotProducts":"热销爆款",
        "goodProducts":"推荐新品",
    },
    search:{
        search:"搜索商品"
    },
    mall:{
        category:"选择分类",
        search:"搜索商品",
    },
    product:{
        price_start:"起步价",
        shipping_fee:"运费",
        category:"分类",
        region_normal:"主要省份",
        region_other:"港澳台和国外99元",
        region_far:"偏远省份12元（新疆、西藏、内蒙、青海、宁夏、甘肃）",
        sells:"销量",
        favorite:"收藏",
        favorited:"已收藏",
        add_cart:"加入购物车",
        buy_now:"立即购买",
        detail:"商品详情",
        comments:"用户评价",
        select:"选择型号",
        stock:"库存",
        buy:"购买",
        preview:"3D预览",
        empty_comments:"暂无评价",
        download:"下载文件",
        concat:"联系",
        hotline:"客服电话",
        email:"电子邮箱",
        com_wechat:"企业微信",
    },
    login:{
        login_register:"登录 / 注册",
        mobile:"手机号",
        code:"验证码",
        send_code:"发送验证码",
        login:"登录",
        input_mobile:"请输入手机号账",
        digit4:"四位数字",
        second:"秒"
    },
    address:{
        concat:"称呼",
        mobile:"手机",
        address:"详细地址",
        modify:"修改地址",
        remove:"删除地址",
        save:"保存地址",
        add:"新增地址",
        zipcode:"邮编",
        digit6:"6位数字",
        mobile11:"11位手机号",
        name:"称呼",
        gender:"性别",
        male:"先生",
        female:"女士",
        province:"地区",     
        please_select:"请选择省市",
        is_mainland:"区域",
    },
    cart:{
        order_now:"立即下单"
    },
    order:{
        order_no:"完整订单号",
        no:"订单号",
        search:"搜索",
        detail:"详情",
        order_detail:"订单详情",
        fee:"金额",
        new_time:"下单时间",
        status:"状态",
        all:"全部",
        shipping_fee:"运费",
        cover:"商品图片",
        product:"商品名称",
        price:"价格",
        count:"数量",
        price_count:"价格和数量",
        order_fee:"订单金额",
        rule:"规则",
        remark:"订单备注",
        address:"收货地址",
        pay_way:"支付方式",
        track:"订单跟踪",
        express_no:"运单号",
        express:"快递公司",
        time:"时间",
        cancel:"取消订单",
        pay_now:"立即支付",
        comments:"订单评价",
        comment:"评价",
        confirm:"确认收货",
        rank:"打分",
        submit:"提交评价",
        wechatpay:"微信支付",
        alipay:"支付宝",
        select_payway:"请选择支付方式",
        support:"我们已经支持",
        paying:"支付中...",
        confirm_cancel:"确认取消订单吗？",
        hour2:"(请在2个小时内扫码支付)",
        scan:"手机微信，扫码支付",
        alipay_please:"支付窗口已打开，请在支付宝页面完成支付",
        pay_done:"已完成支付",
        addresses:"地址管理",
        please_select:"请选择",
        fee_rule:"运费规则",
        order_now:"立即下单",
        region:"区域",
        area:"地区",
        select_area:"请选择地区",
        please_address:"请先选择收货地址!",
        refund:"申请退款",
        reason:"退款原因",
    },
    footer:{
        "product_center":"产品中心",
        "service_notice":"服务说明",
        "notice1":"支持来图来样·OEM/ODM",
        "notice2":"公制/英制·非标定制"
    }
}